// extracted by mini-css-extract-plugin
module.exports =  {"add-item":"add-item-iycwp","input":"input-xcmDi","actions":"actions-iV2qd","add":"add-SjFUs","cancel":"cancel-mErzd","icon":"icon-fsrQ7"};